/**
 * @typedef DadataObjectData
 * @property {string} region_type_full 
 * @property {string} region_with_type
 */

/**
 * @see https://jira.domrf.ru/browse/BANKSITE-10676?focusedCommentId=2124989
 * @param {string} address 
 * @param {DadataObjectData} addressObject 
 * @returns {string}
 */
export const formatAddressForCallCenter = (address, addressObject) => {
  if (!addressObject) return address;

  let result = address;

  if (addressObject.region_type_full !== 'город') {
    const r = new RegExp(`^${addressObject.region_with_type}, `, 'i');
    result = result.replace(r, '');
  }

  return result;
};
